const error = {
  userLimitReached: "ユーザーの制限に達しました。",
};

export { error };
